import React from "react";
import styles from "./FoundationalStage.module.css";
import { cleanLines, stripBoldTitle } from "../OnboardingStage/utils";

const parseShopSeo = (md = "") => {
  const lines = stripBoldTitle(cleanLines(md));
  const introLines = [];
  const actionLines = [];
  let foundExecute = false;

  lines.forEach((line) => {
    if (/we will execute/i.test(line)) {
      foundExecute = true;
      actionLines.push(line.trim());
    } else if (foundExecute) {
      actionLines.push(line.trim());
    } else {
      introLines.push(line);
    }
  });

  return {
    intro: introLines.join(" ").trim(),
    actionText: actionLines.join(" ").trim(),
  };
};

const ShopSeoRemediation = ({ markdown = "" }) => {
  const { intro, actionText } = parseShopSeo(markdown);
  if (!intro && !actionText) return null;

  return (
    <div className={styles.container}>
      <h3 className={styles.heading}>Shop SEO Remediation</h3>
      {intro ? (
        <div className={styles.card}>
          <p className={styles.paragraph}>{intro}</p>
        </div>
      ) : null}
      {actionText ? (
        <div className={styles.actionCard}>
          <p className={styles.actionTitle}>Execution Plan</p>
          <p className={styles.actionText}>{actionText}</p>
        </div>
      ) : null}
    </div>
  );
};

export default ShopSeoRemediation;
